export const banner_style = "overflow-x-hidden w-full h-[58vh] min-h-[300px] text-center flex justify-center items-center bg-black mb-8";

export const styles = {
  container: 'w-full px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20  mx-auto',
  fullWidthImage: 'w-full h-auto object-cover',
  section: 'w-full py-12 px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20',
  twoColumnGrid: 'grid grid-cols-1 md:grid-cols-2 gap-8 items-center',
  heading1: 'text-xl sm:text-2xl md:text-3xl lg:text-5xl xl:text-5xl',
  heading2: 'text-lg sm:text-xl md:text-2xl lg:text-4xl xl:text-4xl',
  heading3: 'text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl',
  paragraph: 'text-sm sm:text-base md:text-lg lg:text-xl xl:text-xl',
  smallText: 'text-xs sm:text-sm md:text-base lg:text-base xl:text-lg',
  buttonText: 'text-sm sm:text-base md:text-base lg:text-lg xl:text-lg',
  label: 'text-xs sm:text-sm md:text-sm lg:text-base xl:text-base',
  caption: 'text-[10px] sm:text-xs md:text-sm lg:text-sm xl:text-base',
};
